module.exports = __webpack_public_path__ + "static/media/generative design.3e20403f.gif";